import CityPageTemplate from "../city-template/CityPageTemplate";
import { gallupConfig } from "./data";

export default function GallupPage() {
  return <CityPageTemplate config={gallupConfig} />;
}